import { offer_reference_from_offer } from './offerObject';

export const offer_board_identity = (offerItem = {}) => {
    return `${offerItem?._id || offerItem?.offerId || offerItem?.ofrId || offer_reference_from_offer(offerItem) || ''}`.trim();
};

export const merge_offer_board_rows = (primaryOffers = [], secondaryOffers = []) => {
    const mergedOffers = [];
    const seenIdentities = new Set();

    [
        ...primaryOffers.map((offerItem, index) => ({ offerItem, identityFallback: `primary_${index}` })),
        ...secondaryOffers.map((offerItem, index) => ({ offerItem, identityFallback: `secondary_${index}` }))
    ].forEach((rowItem) => {
        const identityValue = offer_board_identity(rowItem.offerItem) || rowItem.identityFallback;
        const identityKey = identityValue.toLowerCase();

        if (seenIdentities.has(identityKey)) {
            return;
        }

        seenIdentities.add(identityKey);
        mergedOffers.push(rowItem.offerItem);
    });

    return mergedOffers;
};
